import React from 'react';
import aboutHeroImage from '../../assets/about/hero-team.jpeg';
import './AboutHero.css';

const AboutHero = () => (
  <section className="about-hero">
    <div className="about-hero__inner">
      <div className="about-hero__panel">
        <p className="about-hero__eyebrow">ABOUT US</p>
        <h1 className="about-hero__title">
          Your outdoor space
          <span className="about-hero__title-accent"> in good hands.</span>
        </h1>
        <p className="about-hero__copy">
          A dedicated team with deep roots in the Roaring Fork Valley. We have been caring for outdoor spaces
          between Glenwood to the Aspen area, and we know exactly what local properties need.
        </p>
      </div>
      <div className="about-hero__image-wrap">
        <div className="about-hero__image-frame">
          <img
            src={aboutHeroImage}
            alt="Fresh Start landscaping team"
            className="about-hero__image"
          />
        </div>
      </div>
    </div>
  </section>
);

export default AboutHero;
